import { createHashHistory } from 'history';
import { matchPath } from 'react-router';
var history;
export var navigation = {
  /**
   * 初始化 history
   */
  init: function init() {
    history = createHashHistory();
  },

  /**
   * 获取 history 对象
   */
  getHistory: function getHistory() {
    return history;
  },

  /**
   * 路由跳转
   * @param path - 需跳转路由地址
   */
  goto: function goto(path) {
    history.push(path);
  },

  /**
   * 路由返回
   */
  goBack: function goBack() {
    history.goBack();
  },

  /**
   * 获取当前路由 pathname
   */
  getPathname: function getPathname() {
    return history.location.pathname;
  },

  /**
   * 检查路径是否匹配路由表达式
   * @param path - 路径
   * @param route - 路由表达式
   */
  isPathMatched: function isPathMatched(path, route) {
    return !!matchPath(path, {
      path: route,
      exact: false,
      strict: true
    });
  }
};